import React, { useEffect, useState } from "react";
import styles from "./MemberRegistration.module.css";
const ChilldrenInfo = ({ addChildinfo, done, index, initialData }) => {
  const [childinfo, setChildinfo] = useState(initialData);
  const onChangeHandler = (e) => {
    if (e.target.name === "gender-" + index) {
      setChildinfo({ ...childinfo, gender: e.target.value });
    } else {
      setChildinfo({ ...childinfo, [e.target.name]: e.target.value });
    }
  };

  useEffect(() => {
    addChildinfo(index, childinfo);
  }, [childinfo]);

  return (
    <>
      <div className={`${styles.ChilldrenInfo}`}>
        <h6 className={`${styles.childtitle}`}>
          お子様情報の入力
          <span className={styles.redchild}>
            ※必須項目です。ご出産前の方は予定日をご入力ください。
          </span>
        </h6>
        <hr className={styles.hr} />
        <div className={`d-flex mt-3 ${styles.three}`}>
          <h6 className={styles.label}>お名前</h6>
          <div>
            {done && childinfo.name === "" ? (
              <input
                className={`${styles.firstinput} ${styles.redPlace}`}
                type="text"
                placeholder="※必須入力項目です"
                name="name"
                onChange={onChangeHandler}
                value={childinfo.name}
              />
            ) : (
              <input
                onChange={onChangeHandler}
                className={styles.firstinput}
                type="text"
                placeholder="名"
                name="name"
                value={childinfo.name}
              />
            )}
          </div>
        </div>

        <div className={`d-flex mt-3 ${styles.child2}`}>
          <h6 className={styles.label}>ふりがな</h6>
          <div>
            {done && childinfo.furigana === "" ? (
              <input
                className={`${styles.firstinput} ${styles.redPlace}`}
                type="text"
                placeholder="※必須入力項目です"
                name="furigana"
                onChange={onChangeHandler}
                value={childinfo.furigana}
              />
            ) : (
              <input
                onChange={onChangeHandler}
                className={styles.firstinput}
                type="text"
                placeholder="めい"
                name="furigana"
                value={childinfo.furigana}
              />
            )}
          </div>
        </div>
        <div className={`d-flex ${styles.childradio}`}>
          <h6>性別</h6>

          <div className="d-flex">
            <input
              onChange={onChangeHandler}
              className={styles.radioInput}
              type="radio"
              name={`gender-${index}`}
              value="女の子"
              checked={childinfo.gender === "女の子"}
            />
            <h6 className={styles.radiovalue}>女の子</h6>
          </div>
          <div className="d-flex">
            <input
              onChange={onChangeHandler}
              className={styles.radioInput}
              type="radio"
              name={`gender-${index}`}
              value="男の子"
              checked={childinfo.gender === "男の子"}
            />
            <h6 className={styles.radiovalue}>男の子</h6>
          </div>
          <div className="d-flex">
            <input
              onChange={onChangeHandler}
              className={styles.radioInput}
              type="radio"
              name={`gender-${index}`}
              value="未定"
              checked={childinfo.gender === "未定"}
            />
            <h6 className={styles.radiovalue}>未定</h6>
          </div>
        </div>
        <div className={`d-flex mt-2 ${styles.childLastrow}`}>
          <h6>
            生年月日 <br /> （西暦）
          </h6>
          <div className="d-flex ml-4">
            <input
              onChange={onChangeHandler}
              className={styles.lastinput}
              type="text"
              name="year"
              value={childinfo.year}
            />
            <h6 className={styles.lastinfo}>年</h6>
          </div>
          <div className="d-flex ml-4">
            <input
              onChange={onChangeHandler}
              className={styles.lastinput}
              type="text"
              name="month"
              value={childinfo.month}
            />
            <h6 className={styles.lastinfo}>月</h6>
          </div>
          <div className="d-flex ml-4">
            <input
              onChange={onChangeHandler}
              className={styles.lastinput}
              type="text"
              name="day"
              value={childinfo.day}
            />
            <h6 className={styles.lastinfo}>日</h6>
          </div>
        </div>
      </div>
      {/* <div onClick={addChild} className={`${styles.addChild}`}>
        <h6>+追加のお子様情報</h6>
      </div> */}
    </>
  );
};

export default ChilldrenInfo;
